import { render, staticRenderFns } from "./Leave2.vue?vue&type=template&id=cb323c5e"
import script from "./Leave2.vue?vue&type=script&lang=js"
export * from "./Leave2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports